<template>
  <!-- 消息订阅 -->
  <div class="page-container-manage">
    <el-form :model="messageForm" ref="ruleFormRef" :rules="rulesForm" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
      <el-row>
        <el-row>
          <el-col>
            <el-col style="height:25px;"></el-col>
            <div style="">邮件与微信消息订阅</div>
          </el-col>
        </el-row>
        <!-- 消息订阅表格 begin -->
        <el-col style="height:25px;"></el-col>

        <el-table :data="subscriptionTableDataSource" border>
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="msgTitle"  label="消息说明" width="350" align="center"></el-table-column>
          <el-table-column prop="receiverCustContactType" label="收件人类型" width="369" align="center">
            <template slot-scope="scope">
              <el-select
                multiple
                v-model="scope.row.receiverCustContactType"
                clearable
                default-first-option
                @change="selectType(scope.row.msgSubscriptionDetailId)"
              >
                <el-option
                  v-for="item in TypeOptions"
                  :key="item.name"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="copyCustContactType"  label="抄送人类型" width="369" align="center">
            <template slot-scope="scope">
              <el-select
                multiple
                v-model="scope.row.copyCustContactType"
                clearable
                default-first-option
                onchange="selectType(scope.row.msgSubscriptionDetailId)"
              >
                <el-option
                  v-for="item in TypeOptions"
                  :key="item.name"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="subscribVx"  label="订阅微信消息" width="150">
                      <template slot-scope="scope">
                        <el-switch style="display: block;" v-model="scope.row.State"
                                   @change="change(scope.row.State)" active-color="#13ce66" inactive-color="#D3D3D3">
                        </el-switch>
                      </template>
                    </el-table-column>-->
          <el-table-column prop="isSubscription" label="订阅邮件" width="100" align="center">
            <template slot-scope="scope">
              <el-switch style=""
                         v-model="scope.row.isSubscription"
                         @change="changeTwo(scope.row.msgSubscriptionDetailId)"
                         :active-value="'1'"
                         :inactive-value="'0'"
                         active-color="#13ce66"
                         inactive-color="#D3D3D3">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
        <!-- 表格结束 -->
        <el-row :gutter="50">
          <el-col :span="24" style="width:50%">

            <el-form-item label="收件人邮箱:" prop="addresseeEmail">
              <el-input size="mini" v-model="messageForm.addresseeEmail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="width:30%">
            <el-form-item label="抄送人邮箱:">
              <el-input size="mini" v-model="messageForm.coperEmail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="width:10%">
            <el-form-item label=" ">
              <el-button type="primary" size="small" plain @click="saveMessage()">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-row>
    </el-form>
  </div>
</template>


<script>

import { querySubscription } from "@/api/queryMainSystem";
import {queryDictRows} from "@/api/commonService";

export default {
  data() {
    return {
      TypeOptions: [],
      searchData: {
        msgSubscriptionId: '',
        receiver: '',
        copyReceiver: '',
        subscriptionDetails: [],
        type: '',
        currentPage: 1,
        pageSize: 10
      },

      //订阅信息情况
      subscriptionTableDataSource: [],
      // 表格数据

      rulesForm: {
        addresseeEmail: [{
          required: true,
          message: "收件人邮箱不能为空",
          trigger: ['blur', 'change']
        }]
      },
      messageForm: {
        addresseeEmail: '',
        coperEmail: '',

      },
      // 表格设置
      messageTableSettings: {
        height: 205,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeMe,
        ...this.$systemConfig.tableConfig
      },
    }
  },
 async created() {
    let self = this;
    self.queryCustContactTypeStatus();
    querySubscription(self.searchData).then((res) => {
      if (res.success) {
        self.searchData.msgSubscriptionId = res.records[0].records[0].msgSubscriptionId;
        self.messageForm.addresseeEmail = res.records[0].records[0].receiver;
        self.messageForm.coperEmail = res.records[0].records[0].copyReceiver;
        self.subscriptionTableDataSource = res.records[0].records;
        if(self.subscriptionTableDataSource.length>0){
          self.subscriptionTableDataSource.forEach( item => {
            let a = item.receiverCustContactType.split(",");
            item.receiverCustContactType = [];
            let b = item.copyCustContactType.split(",");
            item.copyCustContactType = [];
            self.TypeOptions.forEach(type => {
              a.forEach( itemValue =>{
                if(type.name === itemValue){
                  item.receiverCustContactType.push(type.value);
                }
              });
              b.forEach( itemValue =>{
                if(type.name === itemValue){
                  item.copyCustContactType.push(type.value);
                }
              });
            })
          });
        }
      }else{
        self.$coreMethods.message("error", "获取订阅信息状态失败，请稍后重试");
      }
    });
  },
  mounted() {
    let self = this;
    self.queryCustContactTypeStatus();
  },
  methods: {
    change(state) {
      this.datas[1].State = false;
      console.log(state);
    },
    selectType(msgSubscriptionDetailId){
      let self = this;

    },
    //邮件订阅状态改变事件
    changeTwo(msgSubscriptionDetailId) {
      let self = this;
      self.subscriptionTableDataSource.forEach(function (subscription){
        if(subscription.msgSubscriptionDetailId === msgSubscriptionDetailId){
          console.info(subscription.isSubscription);
          if(subscription.isSubscription === '0') {
            console.info(subscription.isSubscription);
          }
          if(subscription.isSubscription === '1'){
            console.info(subscription.isSubscription);
          }
        }
      });
    },
    //保存订阅信息状态
    saveMessage(){
      let self = this;
      self.searchData.receiver = self.messageForm.addresseeEmail;
      self.searchData.copyReceiver = self.messageForm.coperEmail;
      let subscriptionDetailsDict = [];
      self.subscriptionTableDataSource.forEach(item => {
        let obj = JSON.parse(JSON.stringify(item));
        subscriptionDetailsDict.push(obj);
      });
      if(subscriptionDetailsDict.length>0){
        subscriptionDetailsDict.forEach( item => {
          let a = [];
          let b = [];
          self.TypeOptions.forEach(type => {
            item.receiverCustContactType.forEach( itemValue =>{
              if(type.value === itemValue){
                a.push(type.name);
              }
            });
            item.copyCustContactType.forEach( itemValue =>{
              if(type.value === itemValue){
                b.push(type.name);
              }
            });
          })
          item.receiverCustContactType = "";
          item.receiverCustContactType = a.toString();
          item.copyCustContactType = "";
          item.copyCustContactType = b.toString();
        });
      }
      self.searchData.subscriptionDetails = subscriptionDetailsDict;
      this.searchData.type = "UPDATE";
      querySubscription(self.searchData).then((res) => {
        if (res.success) {
          self.$coreMethods.message("success", "订阅信息状态修改成功！");
        }else{
          self.$coreMethods.message("error", "订阅信息状态修改失败，请稍后重试！");
        }
      });
    },
    queryCustContactTypeStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$CS_CONTACT_TYPE').then(res => {
        let dict = []
        res.MD_CODE_DICT$CS_CONTACT_TYPE.forEach(item => {
          let param = {};
          param.name = item.key;
          param.value = item.value;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
          this.TypeOptions = dict;
        });
        this.$hotTableUtils.registDict({
          CS_CONTACT_TYPE: dict,
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.page-container-manage{
  height: 100vh;
}
</style>





